export enum Permission {
  BOT_CARDS = 'BOT_CARDS',
  CHAT = 'CHAT',
  MANAGE_ACCOUNTS = 'MANAGE_ACCOUNTS',
  MANAGE_BOTS = 'MANAGE_BOTS',
  MANUAL_BOT_MOVE_CONTROL = 'MANUAL_BOT_MOVE_CONTROL',
  MANAGE_BOTS_SEATING = 'MANAGE_BOTS_SEATING',
  MANAGE_BOTS_PARAMS = 'MANAGE_BOTS_PARAMS',
  CHANGE_BOTS_CLUBS = 'CHANGE_BOTS_CLUBS',
  RESET_BOTS_RESTRICTIONS = 'RESET_BOTS_RESTRICTIONS',
  SEE_ALL_UNIQUE_IDS = 'SEE_ALL_UNIQUE_IDS',
  SHOW_UNIQUE_IDS = 'SHOW_UNIQUE_IDS',
}
